// extracted by mini-css-extract-plugin
export default {"hide":"posts-grid_hide__-zgrQ"};